import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.split";
import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import "vant/lib/dialog/style";
import _Dialog from "vant/lib/dialog";
import _objectSpread from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";

var _actions;

import * as types from "@/store/constants/types";
import FaceClient from "@/api/faceClient/index";
import faceCelebrities from "@/api/faceCelebrities/index";
import FaceTG from "@/api/faceTG/index";
import ZMClient from "@/api/faceZMC";
import { canvasCompress, mergePhoto } from "@/utils/canvasCompress";
import routerTempHelpers from "@/utils/routerTempHelpers";
import { FaceUUid } from "@/api/utils/apiHelper";
import { BUCKET, REGION_TYPE, IDENTITY_POOL_ID } from "@/api/faceZMC/constants";
import { isIos } from "@/utils/lodash";
import { judgeCameraGuide } from "@/utils/judgeVersion";
import { i18n } from "@/i18n/i18n-setup";
import localStorageHelper from "@/localstorage/localstorage";
import HoroScopeClient from "@/api/horoScope";
import faceIdeaClient from "@/api/faceIdea";
import { getBatch } from '@/utils/numUtils';
import { celebritiesNew } from "@/api/faceNewServe/services";
var awsInitStatus = false; //aws初始化状态

var FACE_GUIDE_SHOW_KEY = "FACE_GUIDE_SHOW_KEY";
var HAND_GUIDE_SHOW_KEY = "HAND_GUIDE_SHOW_KEY";
import GeneralUtilsHelper from "@/utils/generalUtils";

var checkCameraAuthorization = function checkCameraAuthorization() {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(resolve, reject) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                Cordova.exec(function (authorization) {
                  resolve(authorization); //只返回了base64
                }, function (error) {
                  reject(error);
                }, "FaceCamera", "checkCameraAuthorization", null);
              } catch (error) {
                reject(error);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var openCarmara = function openCarmara(payload) {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var options;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                options = {
                  quality: 80,
                  zip: true
                };

                if (payload) {
                  options = _objectSpread({}, options, payload);
                }

                console.log("执行Cordova camera:", options);
                Cordova.exec(function (imageData) {
                  console.info("imageData:", imageData);
                  resolve(imageData); //只返回了base64
                }, function (error) {
                  // console.info("error:", error);
                  reject(error);
                }, "FaceCamera", "openCamera", [options]);
              } catch (error) {
                reject(error);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};

var openCameraSetting = function openCameraSetting() {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(resolve, reject) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              try {
                Cordova.exec(function (authorization) {
                  resolve(authorization);
                }, function (error) {
                  reject(error);
                }, "FaceCamera", "openCameraSetting", null);
              } catch (error) {
                reject(error);
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }());
};

var actions = (_actions = {}, _defineProperty(_actions, types.CHECK_CAMERA_GUIDE, function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(_ref4, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            state = _ref4.state, commit = _ref4.commit, dispatch = _ref4.dispatch;
            return _context5.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref6 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee4(resolve, reject) {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.prev = 0;

                        if (judgeCameraGuide()) {
                          _context4.next = 5;
                          break;
                        }

                        console.log("如果是老板本的，不走web的camera guide");
                        resolve();
                        return _context4.abrupt("return");

                      case 5:
                        if (payload.type && payload.type.indexOf("hand") > -1) {
                          //检查手guide
                          if (localStorageHelper.has(HAND_GUIDE_SHOW_KEY)) {
                            resolve();
                          } else {
                            localStorageHelper.set(HAND_GUIDE_SHOW_KEY, "SHOWED");
                            dispatch(types.ROUTER_PUSH, {
                              name: "cameraGuide",
                              params: {
                                transitionType: "forward"
                              },
                              query: {
                                tempKey: routerTempHelpers.setQueryTemp({
                                  resolve: resolve,
                                  reject: reject,
                                  type: "hand"
                                })
                              }
                            });
                          }
                        } else {
                          //检查face guide
                          if (localStorageHelper.has(FACE_GUIDE_SHOW_KEY)) {
                            resolve();
                          } else {
                            localStorageHelper.set(FACE_GUIDE_SHOW_KEY, "SHOWED");
                            dispatch(types.ROUTER_PUSH, {
                              name: "cameraGuide",
                              params: {
                                transitionType: "forward"
                              },
                              query: {
                                tempKey: routerTempHelpers.setQueryTemp({
                                  resolve: resolve,
                                  reject: reject,
                                  type: "face"
                                })
                              }
                            });
                          }
                        }

                        _context4.next = 11;
                        break;

                      case 8:
                        _context4.prev = 8;
                        _context4.t0 = _context4["catch"](0);
                        reject(_context4.t0);

                      case 11:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, null, [[0, 8]]);
              }));

              return function (_x9, _x10) {
                return _ref6.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.TAKE_PHOTO_EX, function () {
  var _ref8 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7(_ref7, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            state = _ref7.state, commit = _ref7.commit, dispatch = _ref7.dispatch;
            return _context7.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref9 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee6(resolve, reject) {
                var ishasOpenedCarmara, checkCameraStatus, carmaraResult, _carmaraResult;

                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.prev = 0;
                        _context6.next = 3;
                        return dispatch(types.CHECK_CAMERA_GUIDE, payload);

                      case 3:
                        ishasOpenedCarmara = localStorage.getItem("is_has_opened_carmara");

                        if (!(ishasOpenedCarmara && isIos())) {
                          _context6.next = 19;
                          break;
                        }

                        console.log("shi ios dakaiguo xiagng ji");
                        _context6.next = 8;
                        return checkCameraAuthorization();

                      case 8:
                        checkCameraStatus = _context6.sent;

                        if (!checkCameraStatus) {
                          _context6.next = 16;
                          break;
                        }

                        _context6.next = 12;
                        return openCarmara(payload);

                      case 12:
                        carmaraResult = _context6.sent;

                        if (carmaraResult && carmaraResult.base64) {
                          resolve(carmaraResult);
                        } else {
                          reject(carmaraResult);
                        }

                        _context6.next = 17;
                        break;

                      case 16:
                        commit(types.SHOW_TOAST, {
                          show: true,
                          title: i18n.t('toast.photo_title'),
                          content: i18n.t('toast.photo_content'),
                          confirm: "<div class=\"flex-center\" style=\"width:100%;height:100%;background:#603BF3;color: #fff;font-family:Assistant-SemiBold;font-size:16px;border-radius:8px;\">".concat(i18n.t('toast.settings'), "</div>"),
                          confirmFn: openCameraSetting,
                          cancel: "<div class=\"flex-center\" style=\"width:100%;height:100%;color:#CDCBD6;;border-radius:8px;\">".concat(i18n.t('toast.cancel'), "</div>")
                        });

                      case 17:
                        _context6.next = 24;
                        break;

                      case 19:
                        localStorage.setItem("is_has_opened_carmara", "true");
                        _context6.next = 22;
                        return openCarmara(payload);

                      case 22:
                        _carmaraResult = _context6.sent;

                        if (_carmaraResult && _carmaraResult.base64) {
                          resolve(_carmaraResult);
                        } else {
                          reject(_carmaraResult);
                        }

                      case 24:
                        _context6.next = 29;
                        break;

                      case 26:
                        _context6.prev = 26;
                        _context6.t0 = _context6["catch"](0);
                        console.log(_context6.t0);

                      case 29:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6, null, [[0, 26]]);
              }));

              return function (_x13, _x14) {
                return _ref9.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function (_x11, _x12) {
    return _ref8.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.AWS_INIT, function () {
  var _ref11 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee9(_ref10, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            state = _ref10.state, commit = _ref10.commit, dispatch = _ref10.dispatch;
            return _context9.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref12 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee8(resolve, reject) {
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        try {
                          //初始化
                          if (awsInitStatus) {
                            resolve(true);
                          } else {
                            Cordova.exec(function (res) {
                              console.info("AwsPlugin init:", res);
                              resolve(true);
                              awsInitStatus = true;
                            }, function (error) {
                              console.info("AwsPlugin init error:", error);
                              resolve(false);
                            }, "AwsPlugin", "init", [{
                              regionType: REGION_TYPE,
                              identityId: IDENTITY_POOL_ID
                            }]);
                          }
                        } catch (error) {
                          resolve(false);
                        }

                      case 1:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              }));

              return function (_x17, _x18) {
                return _ref12.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function (_x15, _x16) {
    return _ref11.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.AWS_UPLOAD, function () {
  var _ref14 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee11(_ref13, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            state = _ref13.state, commit = _ref13.commit, dispatch = _ref13.dispatch;
            return _context11.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref15 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee10(resolve, reject) {
                var result, secretKey, picData;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        _context10.prev = 0;

                        if (awsInitStatus) {
                          _context10.next = 8;
                          break;
                        }

                        _context10.next = 4;
                        return dispatch(types.AWS_INIT);

                      case 4:
                        result = _context10.sent;

                        if (result) {
                          _context10.next = 8;
                          break;
                        }

                        //还是没有初始化成功:
                        reject("Init aws sdk failed again,please check your internet.");
                        return _context10.abrupt("return");

                      case 8:
                        secretKey = "face/" + FaceUUid();
                        picData = payload;
                        Cordova.exec(function (imageData) {
                          console.info("AwsPlugin upload:", imageData);
                          resolve(_objectSpread({}, imageData, {
                            secretKey: secretKey,
                            picData: picData
                          }));
                        }, function (error) {
                          console.info("AwsPlugin upload error:", error);
                          reject(error);
                        }, "AwsPlugin", "upload", [{
                          secretKey: secretKey,
                          picData: picData,
                          bucketId: BUCKET
                        }]);
                        _context10.next = 16;
                        break;

                      case 13:
                        _context10.prev = 13;
                        _context10.t0 = _context10["catch"](0);
                        reject(_context10.t0);

                      case 16:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10, null, [[0, 13]]);
              }));

              return function (_x21, _x22) {
                return _ref15.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function (_x19, _x20) {
    return _ref14.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.PRE_FACE_DETECT, function () {
  var _ref17 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee13(_ref16, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            state = _ref16.state, commit = _ref16.commit, dispatch = _ref16.dispatch;
            return _context13.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref18 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee12(resolve, reject) {
                var type, image_key, result, resovleResult;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        _context12.prev = 0;
                        type = payload.type, image_key = payload.image_key;
                        console.log("PRE_FACE_DETECT", {
                          type: type,
                          image_key: image_key
                        });
                        _context12.prev = 3;
                        _context12.next = 6;
                        return ZMClient.req_face_detect(type, image_key);

                      case 6:
                        result = _context12.sent;
                        //先取出data:
                        resovleResult = JSON.parse(result.data);
                        console.info("PRE_FACE_DETECT result:", resovleResult);
                        resolve(resovleResult);
                        _context12.next = 15;
                        break;

                      case 12:
                        _context12.prev = 12;
                        _context12.t0 = _context12["catch"](3);
                        reject(_context12.t0);

                      case 15:
                        _context12.next = 21;
                        break;

                      case 17:
                        _context12.prev = 17;
                        _context12.t1 = _context12["catch"](0);
                        console.error("PRE_FACE_DETECT error:", _context12.t1);
                        reject(_context12.t1);

                      case 21:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee12, null, [[0, 17], [3, 12]]);
              }));

              return function (_x25, _x26) {
                return _ref18.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function (_x23, _x24) {
    return _ref17.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.PRE_FACE_CHECK, function () {
  var _ref20 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee15(_ref19, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            state = _ref19.state, commit = _ref19.commit, dispatch = _ref19.dispatch;
            return _context15.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref21 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee14(resolve, reject) {
                var type, base64_photo, resolve_base64_photo, result, resovleResult;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        _context14.prev = 0;
                        type = payload.type, base64_photo = payload.base64_photo; // console.log(type, base64_photo);
                        //压缩图片：

                        _context14.next = 4;
                        return canvasCompress("data:image/jpeg;base64," + base64_photo);

                      case 4:
                        resolve_base64_photo = _context14.sent;
                        _context14.next = 7;
                        return FaceClient.req_check(type, resolve_base64_photo);

                      case 7:
                        result = _context14.sent;
                        console.info("result result:", result); //先取出data:

                        resovleResult = JSON.parse(result.data);

                        if (resovleResult.success) {
                          //TODO, 可能存在没有识别出一张脸，faces的数组数量为0,有的请求需要检测出是>=2
                          resolve(resovleResult.data);
                        } else {
                          reject(resovleResult.message);
                        }

                        _context14.next = 17;
                        break;

                      case 13:
                        _context14.prev = 13;
                        _context14.t0 = _context14["catch"](0);
                        console.error("PRE_FACE_CHECK error:", _context14.t0);
                        reject(_context14.t0);

                      case 17:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee14, null, [[0, 13]]);
              }));

              return function (_x29, _x30) {
                return _ref21.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function (_x27, _x28) {
    return _ref20.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.BEAUTY_CONTEST_SCANIG, function () {
  var _ref23 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee17(_ref22, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            state = _ref22.state, commit = _ref22.commit, dispatch = _ref22.dispatch;
            return _context17.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref24 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee16(resolve, reject) {
                var cameraResultOne, cameraResultTwo, zip_base64_photo_one, zip_base64_photo_two, last_base64_photo, result, resovleResult;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                  while (1) {
                    switch (_context16.prev = _context16.next) {
                      case 0:
                        _context16.prev = 0;
                        cameraResultOne = payload.cameraResultOne, cameraResultTwo = payload.cameraResultTwo; // console.log(
                        //   "cameraResultOne, cameraResultTwo",
                        //   cameraResultOne,
                        //   cameraResultTwo
                        // );

                        _context16.next = 4;
                        return canvasCompress("data:image/jpeg;base64," + cameraResultOne);

                      case 4:
                        zip_base64_photo_one = _context16.sent;
                        _context16.next = 7;
                        return canvasCompress("data:image/jpeg;base64," + cameraResultTwo);

                      case 7:
                        zip_base64_photo_two = _context16.sent;
                        _context16.next = 10;
                        return mergePhoto(zip_base64_photo_one, zip_base64_photo_two);

                      case 10:
                        last_base64_photo = _context16.sent;
                        _context16.next = 13;
                        return FaceClient.req_beauty_race(last_base64_photo);

                      case 13:
                        result = _context16.sent;
                        //先取出data:
                        resovleResult = JSON.parse(result.data);
                        console.log("resovleResult", resovleResult);

                        if (resovleResult.success) {
                          //TODO, 可能存在没有识别出一张脸，faces的数组数量为0,有的请求需要检测出是>=2
                          resolve(resovleResult.data);
                        } else {
                          reject(resovleResult);
                        }

                        _context16.next = 22;
                        break;

                      case 19:
                        _context16.prev = 19;
                        _context16.t0 = _context16["catch"](0);
                        reject(_context16.t0);

                      case 22:
                      case "end":
                        return _context16.stop();
                    }
                  }
                }, _callee16, null, [[0, 19]]);
              }));

              return function (_x33, _x34) {
                return _ref24.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function (_x31, _x32) {
    return _ref23.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.BEAUTY_CONTEST, function () {
  var _ref26 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee21(_ref25, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            state = _ref25.state, commit = _ref25.commit, dispatch = _ref25.dispatch;
            return _context21.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref27 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee20(resolve, reject) {
                var cameraResult, scaningJump, preCheckTimes, stepTwoCamera, scaningFunction;
                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                  while (1) {
                    switch (_context20.prev = _context20.next) {
                      case 0:
                        _context20.prev = 0;
                        _context20.next = 3;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          top: {
                            backgroundColor: "#f14a5e",
                            text: i18n.t("common.you"),
                            textColor: "#ffffff"
                          },
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("beauty_contest_page.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("beauty_contest_page.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("beauty_contest_page.camera_title")
                          }
                        });

                      case 3:
                        cameraResult = _context20.sent;

                        scaningJump = function scaningJump(cameraResultOne, cameraResultTwo) {
                          dispatch(types.ROUTER_REPLACE, {
                            name: "beautyContestScaning",
                            query: {
                              tempKey: routerTempHelpers.setQueryTemp({
                                nextStepFunction: function nextStepFunction() {
                                  //告诉下个页面next to do
                                  scaningFunction(cameraResultOne, cameraResultTwo);
                                },
                                imageData: {
                                  // picUrl: cameraResult,
                                  picFileUrl: "",
                                  cameraResultOne: cameraResultOne,
                                  cameraResultTwo: cameraResultTwo
                                },
                                transitionType: "forward"
                              })
                            }
                          });
                        };

                        preCheckTimes = 0; //第二步

                        stepTwoCamera =
                        /*#__PURE__*/
                        function () {
                          var _ref28 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee18(editCameraResult) {
                            var cameraResultTwo;
                            return regeneratorRuntime.wrap(function _callee18$(_context18) {
                              while (1) {
                                switch (_context18.prev = _context18.next) {
                                  case 0:
                                    _context18.prev = 0;
                                    _context18.next = 3;
                                    return dispatch(types.TAKE_PHOTO_EX, {
                                      top: {
                                        backgroundColor: "#603BF3",
                                        text: i18n.t("common.your_rival"),
                                        textColor: "#ffffff"
                                      },
                                      bottom: {
                                        // backgroundColor: "#f14a5e",
                                        text: i18n.t("beauty_contest_page.camera_bottom_text"),
                                        textColor: "#ffffff",
                                        hightLightTextColor: "#FFDD63",
                                        hightLightText: [i18n.t("beauty_contest_page.camera_hight_light_text")]
                                      },
                                      title: {
                                        text: i18n.t("beauty_contest_page.camera_title")
                                      }
                                    });

                                  case 3:
                                    cameraResultTwo = _context18.sent;
                                    _context18.next = 10;
                                    break;

                                  case 6:
                                    _context18.prev = 6;
                                    _context18.t0 = _context18["catch"](0);
                                    //关闭相机：
                                    dispatch(types.ROUTER_GO_BACK, -1);
                                    return _context18.abrupt("return");

                                  case 10:
                                    console.log("执行stepTwoCamera confirmPhoto");
                                    dispatch(types.ROUTER_REPLACE, {
                                      name: "confirmPhoto",
                                      params: {
                                        transitionType: "static"
                                      },
                                      query: {
                                        tempKey: routerTempHelpers.setQueryTemp({
                                          nextStepFunction: function nextStepFunction(editCameraResultTwo) {
                                            //到扫描页面
                                            scaningJump(editCameraResult.base64, editCameraResultTwo.base64);
                                          },
                                          goBackFunction: function goBackFunction() {
                                            dispatch(types.ROUTER_GO_BACK, -1);
                                            stepTwoCamera(editCameraResult);
                                          },
                                          imageData: {
                                            picUrl: cameraResultTwo.base64,
                                            picFileUrl: ""
                                          },
                                          confirmShowScaning: true
                                        })
                                      }
                                    });

                                  case 12:
                                  case "end":
                                    return _context18.stop();
                                }
                              }
                            }, _callee18, null, [[0, 6]]);
                          }));

                          return function stepTwoCamera(_x39) {
                            return _ref28.apply(this, arguments);
                          };
                        }();

                        scaningFunction =
                        /*#__PURE__*/
                        function () {
                          var _ref29 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee19(cameraResultOne, cameraResultTwo) {
                            var beautyContestResult;
                            return regeneratorRuntime.wrap(function _callee19$(_context19) {
                              while (1) {
                                switch (_context19.prev = _context19.next) {
                                  case 0:
                                    _context19.prev = 0;
                                    _context19.next = 3;
                                    return dispatch(types.BEAUTY_CONTEST_SCANIG, {
                                      cameraResultOne: cameraResultOne,
                                      cameraResultTwo: cameraResultTwo
                                    });

                                  case 3:
                                    beautyContestResult = _context19.sent;
                                    console.log("beautyContestResult", beautyContestResult);

                                    if (beautyContestResult && beautyContestResult.length >= 2) {
                                      dispatch(types.ROUTER_REPLACE, {
                                        name: "beautyContestResult",
                                        query: {
                                          beautyContestResult: beautyContestResult,
                                          imageData: {
                                            // picUrl: cameraResult,
                                            picFileUrl: "",
                                            cameraResultOne: cameraResultOne,
                                            cameraResultTwo: cameraResultTwo
                                          },
                                          transitionType: "forward"
                                        }
                                      });
                                    } else {
                                      //没检测到人脸，提示用户重新拍照
                                      console.log("beautyContestResult not checed face");
                                      commit(types.SHOW_FACE_TOAST, function () {
                                        dispatch(types.ROUTER_GO_BACK, -3);
                                        dispatch(types.BEAUTY_CONTEST);
                                      });
                                    }

                                    _context19.next = 13;
                                    break;

                                  case 8:
                                    _context19.prev = 8;
                                    _context19.t0 = _context19["catch"](0);
                                    preCheckTimes++;
                                    console.log("preCheckTimes BEAUTY_CONTEST", preCheckTimes);

                                    if (preCheckTimes <= 4) {
                                      setTimeout(function () {
                                        scaningFunction(cameraResultOne, cameraResultTwo);
                                      }, 3000);
                                    } else {
                                      commit(types.SHOW_NETWORK_TOAST, function () {
                                        dispatch(types.ROUTER_GO_BACK, -2);
                                      });
                                    }

                                  case 13:
                                  case "end":
                                    return _context19.stop();
                                }
                              }
                            }, _callee19, null, [[0, 8]]);
                          }));

                          return function scaningFunction(_x40, _x41) {
                            return _ref29.apply(this, arguments);
                          };
                        }(); //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction(result) {
                                //告诉下个页面next to do
                                stepTwoCamera(result);
                              },
                              goBackFunction: function goBackFunction() {
                                dispatch(types.ROUTER_GO_BACK, -1);
                                dispatch(types.BEAUTY_CONTEST);
                              },
                              imageData: {
                                picUrl: cameraResult.base64,
                                picFileUrl: ""
                              }
                            })
                          }
                        });
                        _context20.next = 14;
                        break;

                      case 11:
                        _context20.prev = 11;
                        _context20.t0 = _context20["catch"](0);
                        console.log('err', _context20.t0);

                      case 14:
                      case "end":
                        return _context20.stop();
                    }
                  }
                }, _callee20, null, [[0, 11]]);
              }));

              return function (_x37, _x38) {
                return _ref27.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));

  return function (_x35, _x36) {
    return _ref26.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.BEAUTY_CONTEST_IOSNEW, function () {
  var _ref31 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee24(_ref30, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            state = _ref30.state, commit = _ref30.commit, dispatch = _ref30.dispatch;
            return _context24.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref32 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee23(resolve, reject) {
                var cameraResultOne, cameraResultTwo, preCheckTimes, scaningFunction;
                return regeneratorRuntime.wrap(function _callee23$(_context23) {
                  while (1) {
                    switch (_context23.prev = _context23.next) {
                      case 0:
                        _context23.prev = 0;
                        _context23.next = 3;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          top: {
                            backgroundColor: "#f14a5e",
                            text: i18n.t("common.you"),
                            textColor: "#ffffff"
                          },
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("beauty_contest_page.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("beauty_contest_page.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("beauty_contest_page.camera_title")
                          },
                          pop_animation: false
                        });

                      case 3:
                        cameraResultOne = _context23.sent;
                        _context23.next = 6;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          top: {
                            backgroundColor: "#603BF3",
                            text: i18n.t("common.your_rival"),
                            textColor: "#ffffff"
                          },
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("beauty_contest_page.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("beauty_contest_page.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("beauty_contest_page.camera_title")
                          },
                          push_animation: false
                        });

                      case 6:
                        cameraResultTwo = _context23.sent;
                        preCheckTimes = 0;

                        scaningFunction =
                        /*#__PURE__*/
                        function () {
                          var _ref33 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee22(resultOne, resultTwo) {
                            var beautyContestResult;
                            return regeneratorRuntime.wrap(function _callee22$(_context22) {
                              while (1) {
                                switch (_context22.prev = _context22.next) {
                                  case 0:
                                    _context22.prev = 0;
                                    _context22.next = 3;
                                    return dispatch(types.BEAUTY_CONTEST_SCANIG, {
                                      cameraResultOne: resultOne,
                                      cameraResultTwo: resultTwo
                                    });

                                  case 3:
                                    beautyContestResult = _context22.sent;

                                    if (beautyContestResult && beautyContestResult.length >= 2) {
                                      dispatch(types.ROUTER_REPLACE, {
                                        name: "beautyContestResult",
                                        query: {
                                          beautyContestResult: beautyContestResult,
                                          imageData: {
                                            // picUrl: cameraResult,
                                            picFileUrl: "",
                                            cameraResultOne: resultOne,
                                            cameraResultTwo: resultTwo
                                          },
                                          transitionType: "forward"
                                        }
                                      });
                                    } else {
                                      //没检测到人脸，提示用户重新拍照
                                      commit(types.SHOW_FACE_TOAST, function () {
                                        dispatch(types.ROUTER_GO_BACK, -3);
                                        dispatch(types.BEAUTY_CONTEST);
                                      });
                                    }

                                    _context22.next = 12;
                                    break;

                                  case 7:
                                    _context22.prev = 7;
                                    _context22.t0 = _context22["catch"](0);
                                    preCheckTimes++;
                                    console.log("preCheckTimes BEAUTY_CONTEST", preCheckTimes);

                                    if (preCheckTimes <= 4) {
                                      setTimeout(function () {
                                        scaningFunction(resultOne, resultOne);
                                      }, 3000);
                                    } else {
                                      commit(types.SHOW_NETWORK_TOAST, function () {
                                        dispatch(types.ROUTER_GO_BACK, -2);
                                      });
                                    }

                                  case 12:
                                  case "end":
                                    return _context22.stop();
                                }
                              }
                            }, _callee22, null, [[0, 7]]);
                          }));

                          return function scaningFunction(_x46, _x47) {
                            return _ref33.apply(this, arguments);
                          };
                        }(); //跳转路由到扫描页面:


                        dispatch(types.ROUTER_REPLACE, {
                          name: "beautyContestScaning",
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction() {
                                //告诉下个页面next to do
                                scaningFunction(cameraResultOne.base64, cameraResultTwo.base64);
                              },
                              imageData: {
                                // picUrl: cameraResult,
                                picFileUrl: "",
                                cameraResultOne: cameraResultOne.base64,
                                cameraResultTwo: cameraResultTwo.base64
                              },
                              transitionType: "forward"
                            })
                          }
                        });
                        _context23.next = 15;
                        break;

                      case 12:
                        _context23.prev = 12;
                        _context23.t0 = _context23["catch"](0);
                        console.log('err', _context23.t0);

                      case 15:
                      case "end":
                        return _context23.stop();
                    }
                  }
                }, _callee23, null, [[0, 12]]);
              }));

              return function (_x44, _x45) {
                return _ref32.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));

  return function (_x42, _x43) {
    return _ref31.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.REQUEST_AGEING_FORECAST, function () {
  var _ref35 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee26(_ref34, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            state = _ref34.state, commit = _ref34.commit, dispatch = _ref34.dispatch;
            return _context26.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref36 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee25(resolve, reject) {
                var image_key, check_result, gender, ethnicity, face_rect, result, resolve_result;
                return regeneratorRuntime.wrap(function _callee25$(_context25) {
                  while (1) {
                    switch (_context25.prev = _context25.next) {
                      case 0:
                        _context25.prev = 0;
                        image_key = payload.image_key, check_result = payload.check_result;
                        gender = check_result.faces[0].attributes.gender.value;
                        ethnicity = check_result.faces[0].attributes.ethnicity.value;
                        face_rect = check_result.faces[0].face_rectangle;
                        _context25.prev = 5;
                        _context25.next = 8;
                        return ZMClient.req_aging_shutter(image_key, ethnicity, gender, face_rect);

                      case 8:
                        result = _context25.sent;
                        resolve_result = JSON.parse(result.data);
                        console.info("req_aging_shutter info:", resolve_result); // if (resolve_result.success) {
                        //   resolve(resolve_result.data);
                        // } else {
                        //   reject(resolve_result.message);
                        // }

                        resolve(resolve_result);
                        _context25.next = 17;
                        break;

                      case 14:
                        _context25.prev = 14;
                        _context25.t0 = _context25["catch"](5);
                        reject(_context25.t0);

                      case 17:
                        _context25.next = 23;
                        break;

                      case 19:
                        _context25.prev = 19;
                        _context25.t1 = _context25["catch"](0);
                        console.error("REQUEST_AGEING_FORECAST error:", _context25.t1);
                        reject(_context25.t1);

                      case 23:
                      case "end":
                        return _context25.stop();
                    }
                  }
                }, _callee25, null, [[0, 19], [5, 14]]);
              }));

              return function (_x50, _x51) {
                return _ref36.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));

  return function (_x48, _x49) {
    return _ref35.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.AGEING_FORECAST, function () {
  var _ref38 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee31(_ref37, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            state = _ref37.state, commit = _ref37.commit, dispatch = _ref37.dispatch;
            return _context31.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref39 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee30(resolve, reject) {
                var cameraResult, preCheckTimes, preFaceCheck;
                return regeneratorRuntime.wrap(function _callee30$(_context30) {
                  while (1) {
                    switch (_context30.prev = _context30.next) {
                      case 0:
                        _context30.prev = 0;
                        _context30.next = 3;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("aging_shutter_page.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("aging_shutter_page.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("aging_shutter_page.camera_title")
                          }
                        });

                      case 3:
                        cameraResult = _context30.sent;
                        preCheckTimes = 0;

                        preFaceCheck =
                        /*#__PURE__*/
                        function () {
                          var _ref40 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee29(editedCameraResult) {
                            var syncGetAgingResult, asyncGetAgingResult, toResult;
                            return regeneratorRuntime.wrap(function _callee29$(_context29) {
                              while (1) {
                                switch (_context29.prev = _context29.next) {
                                  case 0:
                                    _context29.prev = 0;

                                    syncGetAgingResult = function syncGetAgingResult() {
                                      return new _Promise(
                                      /*#__PURE__*/
                                      function () {
                                        var _ref41 = _asyncToGenerator(
                                        /*#__PURE__*/
                                        regeneratorRuntime.mark(function _callee27(sync_resolve, sync_reject) {
                                          var awsResult, result, aging_result;
                                          return regeneratorRuntime.wrap(function _callee27$(_context27) {
                                            while (1) {
                                              switch (_context27.prev = _context27.next) {
                                                case 0:
                                                  _context27.prev = 0;
                                                  _context27.next = 3;
                                                  return dispatch(types.AWS_UPLOAD, editedCameraResult);

                                                case 3:
                                                  awsResult = _context27.sent;
                                                  _context27.next = 6;
                                                  return dispatch(types.PRE_FACE_DETECT, {
                                                    type: 3,
                                                    image_key: awsResult.secretKey
                                                  });

                                                case 6:
                                                  result = _context27.sent;

                                                  if (!(result && result.faces && result.faces.length > 0)) {
                                                    _context27.next = 15;
                                                    break;
                                                  }

                                                  _context27.next = 10;
                                                  return dispatch(types.REQUEST_AGEING_FORECAST, {
                                                    image_key: awsResult.secretKey,
                                                    check_result: result
                                                  });

                                                case 10:
                                                  aging_result = _context27.sent;
                                                  commit(types.UPDATE_RESULT_BY_NAME, {
                                                    name: "agingShutter",
                                                    result: aging_result
                                                  });
                                                  sync_resolve(true);
                                                  _context27.next = 16;
                                                  break;

                                                case 15:
                                                  sync_reject(false);

                                                case 16:
                                                  _context27.next = 21;
                                                  break;

                                                case 18:
                                                  _context27.prev = 18;
                                                  _context27.t0 = _context27["catch"](0);
                                                  sync_reject(false);

                                                case 21:
                                                case "end":
                                                  return _context27.stop();
                                              }
                                            }
                                          }, _callee27, null, [[0, 18]]);
                                        }));

                                        return function (_x57, _x58) {
                                          return _ref41.apply(this, arguments);
                                        };
                                      }());
                                    };

                                    asyncGetAgingResult = function asyncGetAgingResult() {
                                      // const {image_key, check_result} = async_params;
                                      dispatch(types.AWS_UPLOAD, editedCameraResult).then(
                                      /*#__PURE__*/
                                      function () {
                                        var _ref42 = _asyncToGenerator(
                                        /*#__PURE__*/
                                        regeneratorRuntime.mark(function _callee28(async_result) {
                                          var result, aging_result;
                                          return regeneratorRuntime.wrap(function _callee28$(_context28) {
                                            while (1) {
                                              switch (_context28.prev = _context28.next) {
                                                case 0:
                                                  _context28.next = 2;
                                                  return dispatch(types.PRE_FACE_DETECT, {
                                                    type: 3,
                                                    image_key: async_result.secretKey
                                                  });

                                                case 2:
                                                  result = _context28.sent;
                                                  _context28.prev = 3;
                                                  _context28.next = 6;
                                                  return dispatch(types.REQUEST_AGEING_FORECAST, {
                                                    image_key: async_result.secretKey,
                                                    check_result: result
                                                  });

                                                case 6:
                                                  aging_result = _context28.sent;
                                                  console.log("aging_result:", aging_result);
                                                  commit(types.UPDATE_RESULT_BY_NAME, {
                                                    name: "agingShutter",
                                                    result: aging_result
                                                  });
                                                  _context28.next = 13;
                                                  break;

                                                case 11:
                                                  _context28.prev = 11;
                                                  _context28.t0 = _context28["catch"](3);

                                                case 13:
                                                case "end":
                                                  return _context28.stop();
                                              }
                                            }
                                          }, _callee28, null, [[3, 11]]);
                                        }));

                                        return function (_x59) {
                                          return _ref42.apply(this, arguments);
                                        };
                                      }()).catch(function (e) {
                                        _Promise.reject(e);
                                      });
                                    };

                                    toResult = function toResult() {
                                      dispatch(types.ROUTER_PUSH, {
                                        name: "ageingPhoto",
                                        query: {
                                          tempKey: routerTempHelpers.setQueryTemp({
                                            imageData: {
                                              picUrl: editedCameraResult.base64,
                                              syncGetResult: function syncGetResult() {
                                                return syncGetAgingResult();
                                              }
                                            }
                                          })
                                        },
                                        params: {
                                          routerTransition: "forward",
                                          showVipRightNow: true
                                        }
                                      });
                                    };

                                    if (!GeneralUtilsHelper.isVip()) {
                                      _context29.next = 10;
                                      break;
                                    }

                                    _context29.next = 7;
                                    return syncGetAgingResult();

                                  case 7:
                                    toResult();
                                    _context29.next = 12;
                                    break;

                                  case 10:
                                    asyncGetAgingResult();
                                    setTimeout(toResult, getBatch(1500, 2000));

                                  case 12:
                                    _context29.next = 17;
                                    break;

                                  case 14:
                                    _context29.prev = 14;
                                    _context29.t0 = _context29["catch"](0);

                                    if (GeneralUtilsHelper.isVip()) {
                                      preCheckTimes++;
                                      console.log("preCheckTimes", preCheckTimes);

                                      if (preCheckTimes <= 4) {
                                        setTimeout(function () {
                                          preFaceCheck(editedCameraResult);
                                        }, 3000);
                                      } else {
                                        commit(types.SHOW_NETWORK_TOAST, function () {
                                          dispatch(types.ROUTER_GO_BACK, -1);
                                        });
                                      }
                                    }

                                  case 17:
                                  case "end":
                                    return _context29.stop();
                                }
                              }
                            }, _callee29, null, [[0, 14]]);
                          }));

                          return function preFaceCheck(_x56) {
                            return _ref40.apply(this, arguments);
                          };
                        }(); //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction(result) {
                                //告诉下个页面next to do
                                console.log("处理的结果:", result);
                                preFaceCheck(result);
                              },
                              imageData: {
                                picUrl: cameraResult.base64,
                                picFileUrl: cameraResult.filePath,
                                points: cameraResult.points
                              },
                              editFilePath: true,
                              confirmShowScaning: true //点击confirm后显示scaning动画

                            })
                          }
                        });
                        _context30.next = 12;
                        break;

                      case 9:
                        _context30.prev = 9;
                        _context30.t0 = _context30["catch"](0);
                        reject(_context30.t0);

                      case 12:
                      case "end":
                        return _context30.stop();
                    }
                  }
                }, _callee30, null, [[0, 9]]);
              }));

              return function (_x54, _x55) {
                return _ref39.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31);
  }));

  return function (_x52, _x53) {
    return _ref38.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.REQUEST_GENDER_SWITCH, function () {
  var _ref44 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee33(_ref43, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            state = _ref43.state, commit = _ref43.commit, dispatch = _ref43.dispatch;
            return _context33.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref45 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee32(resolve, reject) {
                var image_key, check_result, type, gender, ethnicity, face_rect, result;
                return regeneratorRuntime.wrap(function _callee32$(_context32) {
                  while (1) {
                    switch (_context32.prev = _context32.next) {
                      case 0:
                        _context32.prev = 0;
                        image_key = payload.image_key, check_result = payload.check_result, type = payload.type;
                        gender = check_result.faces[0].attributes.gender.value;
                        ethnicity = check_result.faces[0].attributes.ethnicity.value;
                        face_rect = check_result.faces[0].face_rectangle;
                        _context32.next = 7;
                        return ZMClient.req_gender_switch(image_key, ethnicity, gender, face_rect, type);

                      case 7:
                        result = _context32.sent;
                        resolve(result.data);
                        _context32.next = 15;
                        break;

                      case 11:
                        _context32.prev = 11;
                        _context32.t0 = _context32["catch"](0);
                        console.error("REQUEST_GENDER_SWITCH error:", _context32.t0);
                        reject(_context32.t0);

                      case 15:
                      case "end":
                        return _context32.stop();
                    }
                  }
                }, _callee32, null, [[0, 11]]);
              }));

              return function (_x62, _x63) {
                return _ref45.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33);
  }));

  return function (_x60, _x61) {
    return _ref44.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.GENDER_SWITCH, function () {
  var _ref47 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee38(_ref46, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            state = _ref46.state, commit = _ref46.commit, dispatch = _ref46.dispatch;
            return _context38.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref48 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee37(resolve, reject) {
                var cameraResult, preCheckTimes, preFaceCheck;
                return regeneratorRuntime.wrap(function _callee37$(_context37) {
                  while (1) {
                    switch (_context37.prev = _context37.next) {
                      case 0:
                        _context37.prev = 0;
                        _context37.next = 3;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("common.camera.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("common.camera.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.gender_switch")
                          }
                        });

                      case 3:
                        cameraResult = _context37.sent;
                        preCheckTimes = 0;

                        preFaceCheck =
                        /*#__PURE__*/
                        function () {
                          var _ref49 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee36(editedCameraResult) {
                            var syncGenderSwitchResult, asyncGenderSwitchResult, toResult;
                            return regeneratorRuntime.wrap(function _callee36$(_context36) {
                              while (1) {
                                switch (_context36.prev = _context36.next) {
                                  case 0:
                                    _context36.prev = 0;

                                    syncGenderSwitchResult = function syncGenderSwitchResult() {
                                      return new _Promise(
                                      /*#__PURE__*/
                                      function () {
                                        var _ref50 = _asyncToGenerator(
                                        /*#__PURE__*/
                                        regeneratorRuntime.mark(function _callee34(sync_resolve, sync_reject) {
                                          var awsResult, result, aging_result;
                                          return regeneratorRuntime.wrap(function _callee34$(_context34) {
                                            while (1) {
                                              switch (_context34.prev = _context34.next) {
                                                case 0:
                                                  _context34.prev = 0;
                                                  _context34.next = 3;
                                                  return dispatch(types.AWS_UPLOAD, editedCameraResult);

                                                case 3:
                                                  awsResult = _context34.sent;
                                                  _context34.next = 6;
                                                  return dispatch(types.PRE_FACE_DETECT, {
                                                    type: 3,
                                                    image_key: awsResult.secretKey
                                                  });

                                                case 6:
                                                  result = _context34.sent;

                                                  if (!(result && result.faces && result.faces.length > 0)) {
                                                    _context34.next = 17;
                                                    break;
                                                  }

                                                  _context34.next = 10;
                                                  return dispatch(types.REQUEST_GENDER_SWITCH, {
                                                    image_key: awsResult.secretKey,
                                                    check_result: result,
                                                    type: 3 //先请求学生的 type 1=Business 2=Leisure 3=Student

                                                  });

                                                case 10:
                                                  aging_result = _context34.sent;
                                                  commit(types.UPDATE_RESULT_BY_NAME, {
                                                    name: "genderSwitch",
                                                    result: {
                                                      student: aging_result
                                                    }
                                                  });
                                                  sync_resolve(true); // 异步请求其他两种类型

                                                  dispatch(types.REQUEST_GENDER_SWITCH, {
                                                    image_key: awsResult.secretKey,
                                                    check_result: result,
                                                    type: 2 //先请求学生的 type 1=Business 2=Leisure 3=Student

                                                  }).then(function (casual_result) {
                                                    commit(types.UPDATE_RESULT_BY_NAME, {
                                                      name: "genderSwitch",
                                                      result: {
                                                        casual: casual_result
                                                      }
                                                    });
                                                  });
                                                  dispatch(types.REQUEST_GENDER_SWITCH, {
                                                    image_key: awsResult.secretKey,
                                                    check_result: result,
                                                    type: 1 //先请求学生的 type 1=Business 2=Leisure 3=Student

                                                  }).then(function (business_result) {
                                                    commit(types.UPDATE_RESULT_BY_NAME, {
                                                      name: "genderSwitch",
                                                      result: {
                                                        business: business_result
                                                      }
                                                    });
                                                  });
                                                  _context34.next = 18;
                                                  break;

                                                case 17:
                                                  sync_reject(false);

                                                case 18:
                                                  _context34.next = 23;
                                                  break;

                                                case 20:
                                                  _context34.prev = 20;
                                                  _context34.t0 = _context34["catch"](0);
                                                  sync_reject(false);

                                                case 23:
                                                case "end":
                                                  return _context34.stop();
                                              }
                                            }
                                          }, _callee34, null, [[0, 20]]);
                                        }));

                                        return function (_x69, _x70) {
                                          return _ref50.apply(this, arguments);
                                        };
                                      }());
                                    };

                                    asyncGenderSwitchResult = function asyncGenderSwitchResult() {
                                      // const {image_key, check_result} = async_params;
                                      dispatch(types.AWS_UPLOAD, editedCameraResult).then(
                                      /*#__PURE__*/
                                      function () {
                                        var _ref51 = _asyncToGenerator(
                                        /*#__PURE__*/
                                        regeneratorRuntime.mark(function _callee35(async_result) {
                                          var result, aging_result;
                                          return regeneratorRuntime.wrap(function _callee35$(_context35) {
                                            while (1) {
                                              switch (_context35.prev = _context35.next) {
                                                case 0:
                                                  _context35.next = 2;
                                                  return dispatch(types.PRE_FACE_DETECT, {
                                                    type: 3,
                                                    image_key: async_result.secretKey
                                                  });

                                                case 2:
                                                  result = _context35.sent;
                                                  _context35.next = 5;
                                                  return dispatch(types.REQUEST_GENDER_SWITCH, {
                                                    image_key: async_result.secretKey,
                                                    check_result: result,
                                                    type: 3 //先请求学生的 type 1=Business 2=Leisure 3=Student

                                                  });

                                                case 5:
                                                  aging_result = _context35.sent;
                                                  commit(types.UPDATE_RESULT_BY_NAME, {
                                                    name: "genderSwitch",
                                                    result: {
                                                      student: aging_result
                                                    }
                                                  }); // 异步请求其他两种类型

                                                  dispatch(types.REQUEST_GENDER_SWITCH, {
                                                    image_key: async_result.secretKey,
                                                    check_result: result,
                                                    type: 2 //先请求学生的 type 1=Business 2=Leisure 3=Student

                                                  }).then(function (casual_result) {
                                                    commit(types.UPDATE_RESULT_BY_NAME, {
                                                      name: "genderSwitch",
                                                      result: {
                                                        casual: casual_result
                                                      }
                                                    });
                                                  });
                                                  dispatch(types.REQUEST_GENDER_SWITCH, {
                                                    image_key: async_result.secretKey,
                                                    check_result: result,
                                                    type: 1 //先请求学生的 type 1=Business 2=Leisure 3=Student

                                                  }).then(function (business_result) {
                                                    commit(types.UPDATE_RESULT_BY_NAME, {
                                                      name: "genderSwitch",
                                                      result: {
                                                        business: business_result
                                                      }
                                                    });
                                                  });

                                                case 9:
                                                case "end":
                                                  return _context35.stop();
                                              }
                                            }
                                          }, _callee35);
                                        }));

                                        return function (_x71) {
                                          return _ref51.apply(this, arguments);
                                        };
                                      }()).catch(function (e) {
                                        _Promise.reject(e);
                                      });
                                    };

                                    toResult = function toResult() {
                                      dispatch(types.ROUTER_PUSH, {
                                        name: "genderSwitch",
                                        query: {
                                          tempKey: routerTempHelpers.setQueryTemp({
                                            imageData: {
                                              picUrl: editedCameraResult.base64,
                                              picFileUrl: editedCameraResult.filePath,
                                              // checkResult: result,
                                              syncGetResult: function syncGetResult() {
                                                return syncGenderSwitchResult();
                                              } // image_key: awsResult.secretKey

                                            }
                                          })
                                        },
                                        params: {
                                          routerTransition: "forward",
                                          showVipRightNow: true
                                        }
                                      });
                                    };

                                    if (!GeneralUtilsHelper.isVip()) {
                                      _context36.next = 10;
                                      break;
                                    }

                                    _context36.next = 7;
                                    return syncGenderSwitchResult();

                                  case 7:
                                    toResult();
                                    _context36.next = 12;
                                    break;

                                  case 10:
                                    asyncGenderSwitchResult();
                                    setTimeout(toResult, getBatch(1500, 2000));

                                  case 12:
                                    _context36.next = 17;
                                    break;

                                  case 14:
                                    _context36.prev = 14;
                                    _context36.t0 = _context36["catch"](0);

                                    if (GeneralUtilsHelper.isVip()) {
                                      preCheckTimes++;
                                      console.log("preCheckTimes", preCheckTimes);

                                      if (preCheckTimes <= 4) {
                                        setTimeout(function () {
                                          preFaceCheck(editedCameraResult);
                                        }, 3000);
                                      } else {
                                        commit(types.SHOW_NETWORK_TOAST, function () {
                                          dispatch(types.ROUTER_GO_BACK, -1);
                                        });
                                      }
                                    }

                                  case 17:
                                  case "end":
                                    return _context36.stop();
                                }
                              }
                            }, _callee36, null, [[0, 14]]);
                          }));

                          return function preFaceCheck(_x68) {
                            return _ref49.apply(this, arguments);
                          };
                        }(); //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction(result) {
                                //告诉下个页面next to do
                                preFaceCheck(result);
                              },
                              imageData: {
                                picUrl: cameraResult.base64,
                                picFileUrl: cameraResult.filePath,
                                points: cameraResult.points
                              },
                              editFilePath: true,
                              confirmShowScaning: true //点击confirm后显示scaning动画

                            })
                          }
                        });
                        _context37.next = 12;
                        break;

                      case 9:
                        _context37.prev = 9;
                        _context37.t0 = _context37["catch"](0);
                        reject(_context37.t0);

                      case 12:
                      case "end":
                        return _context37.stop();
                    }
                  }
                }, _callee37, null, [[0, 9]]);
              }));

              return function (_x66, _x67) {
                return _ref48.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38);
  }));

  return function (_x64, _x65) {
    return _ref47.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.ETHNICITY_SCANNER, function () {
  var _ref53 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee46(_ref52, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            state = _ref52.state, commit = _ref52.commit, dispatch = _ref52.dispatch;
            return _context46.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref54 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee45(resolve, reject) {
                var cameraResult, preCheckTimes, preFaceCheck, requestdata;
                return regeneratorRuntime.wrap(function _callee45$(_context45) {
                  while (1) {
                    switch (_context45.prev = _context45.next) {
                      case 0:
                        _context45.prev = 0;
                        _context45.next = 3;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("common.camera.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("common.camera.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.ethnicity_scanner")
                          }
                        });

                      case 3:
                        cameraResult = _context45.sent;
                        preCheckTimes = 0;

                        preFaceCheck =
                        /*#__PURE__*/
                        function () {
                          var _ref55 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee43(editCameraResult) {
                            var syncEthnicityScanner, asyncEthnicityScanner, handleCheckResult;
                            return regeneratorRuntime.wrap(function _callee43$(_context43) {
                              while (1) {
                                switch (_context43.prev = _context43.next) {
                                  case 0:
                                    _context43.prev = 0;

                                    syncEthnicityScanner =
                                    /*#__PURE__*/
                                    function () {
                                      var _ref56 = _asyncToGenerator(
                                      /*#__PURE__*/
                                      regeneratorRuntime.mark(function _callee40(rePhoto) {
                                        return regeneratorRuntime.wrap(function _callee40$(_context40) {
                                          while (1) {
                                            switch (_context40.prev = _context40.next) {
                                              case 0:
                                                return _context40.abrupt("return", new _Promise(
                                                /*#__PURE__*/
                                                function () {
                                                  var _ref57 = _asyncToGenerator(
                                                  /*#__PURE__*/
                                                  regeneratorRuntime.mark(function _callee39(sync_resolve, sync_reject) {
                                                    var faceCheckresult;
                                                    return regeneratorRuntime.wrap(function _callee39$(_context39) {
                                                      while (1) {
                                                        switch (_context39.prev = _context39.next) {
                                                          case 0:
                                                            _context39.prev = 0;
                                                            _context39.next = 3;
                                                            return dispatch(types.PRE_FACE_CHECK, {
                                                              type: 3,
                                                              base64_photo: editCameraResult.base64
                                                            });

                                                          case 3:
                                                            faceCheckresult = _context39.sent;
                                                            _context39.next = 6;
                                                            return handleCheckResult(faceCheckresult, rePhoto);

                                                          case 6:
                                                            sync_resolve(true);
                                                            _context39.next = 12;
                                                            break;

                                                          case 9:
                                                            _context39.prev = 9;
                                                            _context39.t0 = _context39["catch"](0);
                                                            sync_reject(false);

                                                          case 12:
                                                          case "end":
                                                            return _context39.stop();
                                                        }
                                                      }
                                                    }, _callee39, null, [[0, 9]]);
                                                  }));

                                                  return function (_x78, _x79) {
                                                    return _ref57.apply(this, arguments);
                                                  };
                                                }()));

                                              case 1:
                                              case "end":
                                                return _context40.stop();
                                            }
                                          }
                                        }, _callee40);
                                      }));

                                      return function syncEthnicityScanner(_x77) {
                                        return _ref56.apply(this, arguments);
                                      };
                                    }();

                                    asyncEthnicityScanner = function asyncEthnicityScanner() {
                                      dispatch(types.PRE_FACE_CHECK, {
                                        type: 3,
                                        base64_photo: editCameraResult.base64
                                      }).then(
                                      /*#__PURE__*/
                                      function () {
                                        var _ref58 = _asyncToGenerator(
                                        /*#__PURE__*/
                                        regeneratorRuntime.mark(function _callee41(faceCheckresult) {
                                          return regeneratorRuntime.wrap(function _callee41$(_context41) {
                                            while (1) {
                                              switch (_context41.prev = _context41.next) {
                                                case 0:
                                                  _context41.next = 2;
                                                  return handleCheckResult(faceCheckresult);

                                                case 2:
                                                case "end":
                                                  return _context41.stop();
                                              }
                                            }
                                          }, _callee41);
                                        }));

                                        return function (_x80) {
                                          return _ref58.apply(this, arguments);
                                        };
                                      }()).catch(function (e) {
                                        console.log("asyncEthnicityScanner error");
                                      });
                                    };

                                    handleCheckResult =
                                    /*#__PURE__*/
                                    function () {
                                      var _ref59 = _asyncToGenerator(
                                      /*#__PURE__*/
                                      regeneratorRuntime.mark(function _callee42(faceCheckresult, rePhoto) {
                                        return regeneratorRuntime.wrap(function _callee42$(_context42) {
                                          while (1) {
                                            switch (_context42.prev = _context42.next) {
                                              case 0:
                                                if (!(faceCheckresult && faceCheckresult.result && faceCheckresult.result.faces.length > 0)) {
                                                  _context42.next = 5;
                                                  break;
                                                }

                                                _context42.next = 3;
                                                return requestdata(rePhoto);

                                              case 3:
                                                _context42.next = 8;
                                                break;

                                              case 5:
                                                //没检测到人脸，提示用户重新拍照
                                                console.log("ethnicity not checed face");
                                                rePhoto && commit(types.SHOW_FACE_TOAST, function () {
                                                  dispatch(types.ROUTER_GO_BACK, -1);
                                                  dispatch(types.ETHNICITY_SCANNER);
                                                });

                                                _Promise.reject("rePhoto");

                                              case 8:
                                              case "end":
                                                return _context42.stop();
                                            }
                                          }
                                        }, _callee42);
                                      }));

                                      return function handleCheckResult(_x81, _x82) {
                                        return _ref59.apply(this, arguments);
                                      };
                                    }();

                                    if (!GeneralUtilsHelper.isVip()) {
                                      _context43.next = 9;
                                      break;
                                    }

                                    _context43.next = 7;
                                    return syncEthnicityScanner(true);

                                  case 7:
                                    _context43.next = 11;
                                    break;

                                  case 9:
                                    asyncEthnicityScanner();
                                    setTimeout(function () {
                                      dispatch(types.ROUTER_REPLACE, {
                                        name: "ethnicityScanner",
                                        query: {
                                          tempKey: routerTempHelpers.setQueryTemp({
                                            imageData: "data:image/jpeg;base64," + cameraResult.base64,
                                            syncGetResult: function syncGetResult() {
                                              return syncEthnicityScanner();
                                            }
                                          })
                                        },
                                        params: {
                                          routerTransition: "forward",
                                          showVipRightNow: true
                                        }
                                      });
                                    }, getBatch(1500, 2000));

                                  case 11:
                                    _context43.next = 16;
                                    break;

                                  case 13:
                                    _context43.prev = 13;
                                    _context43.t0 = _context43["catch"](0);

                                    if (GeneralUtilsHelper.isVip() && _context43.t0 !== 'rePhoto' && _context43.t0 !== 'result failed') {
                                      preCheckTimes++;
                                      console.log("preCheckTimes ETHNICITY", preCheckTimes);

                                      if (preCheckTimes <= 4) {
                                        setTimeout(function () {
                                          preFaceCheck(editCameraResult);
                                        }, 3000);
                                      } else {
                                        console.log("SHOW_NETWORK_TOAST");
                                        commit(types.SHOW_NETWORK_TOAST, function () {
                                          dispatch(types.ROUTER_GO_BACK, -1);
                                        });
                                      }
                                    }

                                  case 16:
                                  case "end":
                                    return _context43.stop();
                                }
                              }
                            }, _callee43, null, [[0, 13]]);
                          }));

                          return function preFaceCheck(_x76) {
                            return _ref55.apply(this, arguments);
                          };
                        }();

                        requestdata =
                        /*#__PURE__*/
                        function () {
                          var _ref60 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee44(rePhoto) {
                            var zip_base64_photo, result;
                            return regeneratorRuntime.wrap(function _callee44$(_context44) {
                              while (1) {
                                switch (_context44.prev = _context44.next) {
                                  case 0:
                                    _context44.next = 2;
                                    return canvasCompress("data:image/jpeg;base64," + cameraResult.base64);

                                  case 2:
                                    zip_base64_photo = _context44.sent;
                                    _context44.next = 5;
                                    return FaceClient.req_ethnicity(zip_base64_photo);

                                  case 5:
                                    result = _context44.sent;
                                    console.log("result", result);

                                    if (result && JSON.parse(result.data) && JSON.parse(result.data).data) {
                                      commit(types.UPDATE_RESULT_BY_NAME, {
                                        name: "ethnicityScanner",
                                        result: result.data
                                      }); // 如果是vip的情况下同步获取结果

                                      rePhoto && dispatch(types.ROUTER_REPLACE, {
                                        name: "ethnicityScanner",
                                        query: {
                                          tempKey: routerTempHelpers.setQueryTemp({
                                            imageData: zip_base64_photo,
                                            transitionType: "forward"
                                          })
                                        }
                                      });
                                    } else {
                                      _Dialog.confirm({
                                        title: "ERROR",
                                        message: "get result failed",
                                        confirmButtonText: "RETRY",
                                        cancelButtonText: "CANCEL"
                                      }).then(function () {
                                        // on confirm
                                        requestdata(true);
                                      }).catch(function () {
                                        // on cancel
                                        dispatch(types.ROUTER_GO_BACK, -1);
                                      });

                                      _Promise.reject("result failed");
                                    }

                                  case 8:
                                  case "end":
                                    return _context44.stop();
                                }
                              }
                            }, _callee44);
                          }));

                          return function requestdata(_x83) {
                            return _ref60.apply(this, arguments);
                          };
                        }(); //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction(result) {
                                //告诉下个页面next to do
                                preFaceCheck(result); // jumpToScaningPage();
                              },
                              imageData: {
                                picUrl: cameraResult.base64,
                                picFileUrl: "",
                                points: cameraResult.points
                              },
                              confirmShowScaning: true
                            })
                          }
                        });
                        _context45.next = 13;
                        break;

                      case 10:
                        _context45.prev = 10;
                        _context45.t0 = _context45["catch"](0);
                        reject(_context45.t0);

                      case 13:
                      case "end":
                        return _context45.stop();
                    }
                  }
                }, _callee45, null, [[0, 10]]);
              }));

              return function (_x74, _x75) {
                return _ref54.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46);
  }));

  return function (_x72, _x73) {
    return _ref53.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.FUTURE_BABY, function () {
  var _ref62 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee49(_ref61, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            state = _ref61.state, commit = _ref61.commit, dispatch = _ref61.dispatch;
            return _context49.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref63 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee48(resolve, reject) {
                var cameraResult, stepTwoCamera, scaningJump;
                return regeneratorRuntime.wrap(function _callee48$(_context48) {
                  while (1) {
                    switch (_context48.prev = _context48.next) {
                      case 0:
                        _context48.prev = 0;
                        _context48.next = 3;
                        return dispatch(types.TAKE_PHOTO, {
                          top: {
                            backgroundColor: "#f14a5e",
                            text: i18n.t("common.you"),
                            textColor: "#ffffff"
                          },
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("common.camera.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("common.camera.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.future_baby")
                          }
                        });

                      case 3:
                        cameraResult = _context48.sent;

                        //第二步
                        stepTwoCamera =
                        /*#__PURE__*/
                        function () {
                          var _ref64 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee47() {
                            var cameraResultTwo;
                            return regeneratorRuntime.wrap(function _callee47$(_context47) {
                              while (1) {
                                switch (_context47.prev = _context47.next) {
                                  case 0:
                                    _context47.prev = 0;
                                    _context47.next = 3;
                                    return dispatch(types.TAKE_PHOTO, {
                                      top: {
                                        backgroundColor: "#603BF3",
                                        text: i18n.t("common.partner"),
                                        textColor: "#ffffff"
                                      },
                                      bottom: {
                                        // backgroundColor: "#f14a5e",
                                        text: i18n.t("common.camera.camera_bottom_text"),
                                        textColor: "#ffffff",
                                        hightLightTextColor: "#FFDD63",
                                        hightLightText: [i18n.t("common.camera.camera_hight_light_text")]
                                      },
                                      title: {
                                        text: i18n.t("home_page.main_function_list.future_baby")
                                      }
                                    });

                                  case 3:
                                    cameraResultTwo = _context47.sent;
                                    console.log("执行stepTwoCamera confirmPhoto");
                                    dispatch(types.ROUTER_REPLACE, {
                                      name: "confirmPhoto",
                                      params: {
                                        transitionType: "static"
                                      },
                                      query: {
                                        tempKey: routerTempHelpers.setQueryTemp({
                                          nextStepFunction: function nextStepFunction() {
                                            //到扫描页面
                                            scaningJump(cameraResult, cameraResultTwo);
                                          },
                                          imageData: {
                                            picUrl: cameraResultTwo,
                                            picFileUrl: "",
                                            points: cameraResultTwo.points
                                          }
                                        })
                                      }
                                    });
                                    _context47.next = 10;
                                    break;

                                  case 8:
                                    _context47.prev = 8;
                                    _context47.t0 = _context47["catch"](0);

                                  case 10:
                                  case "end":
                                    return _context47.stop();
                                }
                              }
                            }, _callee47, null, [[0, 8]]);
                          }));

                          return function stepTwoCamera() {
                            return _ref64.apply(this, arguments);
                          };
                        }();

                        scaningJump = function scaningJump(cameraResultOne, cameraResultTwo) {
                          dispatch(types.ROUTER_REPLACE, {
                            name: "composeProcess",
                            query: {
                              tempKey: routerTempHelpers.setQueryTemp({
                                imageData: {
                                  picFileUrl: "",
                                  cameraResultOne: cameraResultOne,
                                  cameraResultTwo: cameraResultTwo
                                },
                                transitionType: "forward"
                              })
                            }
                          });
                        }; //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction() {
                                //告诉下个页面next to do
                                stepTwoCamera();
                              },
                              imageData: {
                                picUrl: cameraResult,
                                picFileUrl: "",
                                points: cameraResult.points
                              }
                            })
                          }
                        });
                        _context48.next = 12;
                        break;

                      case 9:
                        _context48.prev = 9;
                        _context48.t0 = _context48["catch"](0);
                        console.log('err future baby', _context48.t0);

                      case 12:
                      case "end":
                        return _context48.stop();
                    }
                  }
                }, _callee48, null, [[0, 9]]);
              }));

              return function (_x86, _x87) {
                return _ref63.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49);
  }));

  return function (_x84, _x85) {
    return _ref62.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.FUTURE_BABY_NEW, function () {
  var _ref66 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee52(_ref65, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            state = _ref65.state, commit = _ref65.commit, dispatch = _ref65.dispatch;
            return _context52.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref67 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee51(resolve, reject) {
                var cameraResult, stepTwoCamera, scaningJump;
                return regeneratorRuntime.wrap(function _callee51$(_context51) {
                  while (1) {
                    switch (_context51.prev = _context51.next) {
                      case 0:
                        console.log("FUTURE_BABY_NEW");
                        _context51.prev = 1;
                        _context51.next = 4;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          top: {
                            backgroundColor: "#f14a5e",
                            text: i18n.t("common.you"),
                            textColor: "#ffffff"
                          },
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("common.camera.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("common.camera.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.future_baby")
                          }
                        });

                      case 4:
                        cameraResult = _context51.sent;

                        //第二步
                        stepTwoCamera =
                        /*#__PURE__*/
                        function () {
                          var _ref68 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee50(image_one) {
                            var cameraResultTwo;
                            return regeneratorRuntime.wrap(function _callee50$(_context50) {
                              while (1) {
                                switch (_context50.prev = _context50.next) {
                                  case 0:
                                    _context50.prev = 0;
                                    _context50.next = 3;
                                    return dispatch(types.TAKE_PHOTO_EX, {
                                      top: {
                                        backgroundColor: "#603BF3",
                                        text: i18n.t("common.partner"),
                                        textColor: "#ffffff"
                                      },
                                      bottom: {
                                        // backgroundColor: "#f14a5e",
                                        text: i18n.t("common.camera.camera_bottom_text"),
                                        textColor: "#ffffff",
                                        hightLightTextColor: "#FFDD63",
                                        hightLightText: [i18n.t("common.camera.camera_hight_light_text")]
                                      },
                                      title: {
                                        text: i18n.t("home_page.main_function_list.future_baby")
                                      }
                                    });

                                  case 3:
                                    cameraResultTwo = _context50.sent;
                                    console.log("执行stepTwoCamera confirmPhoto");
                                    dispatch(types.ROUTER_REPLACE, {
                                      name: "confirmPhoto",
                                      params: {
                                        transitionType: "static"
                                      },
                                      query: {
                                        tempKey: routerTempHelpers.setQueryTemp({
                                          nextStepFunction: function nextStepFunction(image_two) {
                                            //到扫描页面
                                            scaningJump(image_one, image_two);
                                          },
                                          imageData: {
                                            picUrl: cameraResultTwo.base64,
                                            picFileUrl: cameraResult.filePath,
                                            points: cameraResult.points
                                          },
                                          editFilePath: true,
                                          goBackFunction: function goBackFunction() {
                                            stepTwoCamera(image_one);
                                            setTimeout(function () {
                                              dispatch(types.ROUTER_GO_BACK, -1);
                                            }, 400);
                                          }
                                        })
                                      }
                                    });
                                    _context50.next = 10;
                                    break;

                                  case 8:
                                    _context50.prev = 8;
                                    _context50.t0 = _context50["catch"](0);

                                  case 10:
                                  case "end":
                                    return _context50.stop();
                                }
                              }
                            }, _callee50, null, [[0, 8]]);
                          }));

                          return function stepTwoCamera(_x92) {
                            return _ref68.apply(this, arguments);
                          };
                        }();

                        scaningJump = function scaningJump(cameraResultOne, cameraResultTwo) {
                          dispatch(types.ROUTER_REPLACE, {
                            name: "composeProcess",
                            query: {
                              tempKey: routerTempHelpers.setQueryTemp({
                                imageData: {
                                  picFileUrl: "",
                                  cameraResultOne: cameraResultOne,
                                  cameraResultTwo: cameraResultTwo
                                },
                                transitionType: "forward"
                              })
                            }
                          });
                        }; //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction(image_one) {
                                //告诉下个页面next to do
                                stepTwoCamera(image_one);
                              },
                              imageData: {
                                picUrl: cameraResult.base64,
                                picFileUrl: cameraResult.filePath,
                                points: cameraResult.points
                              },
                              editFilePath: true,
                              goBackFunction: function goBackFunction() {
                                dispatch(types.FUTURE_BABY_NEW);
                                setTimeout(function () {
                                  dispatch(types.ROUTER_GO_BACK, -1);
                                }, 400);
                              }
                            })
                          }
                        });
                        _context51.next = 12;
                        break;

                      case 10:
                        _context51.prev = 10;
                        _context51.t0 = _context51["catch"](1);

                      case 12:
                      case "end":
                        return _context51.stop();
                    }
                  }
                }, _callee51, null, [[1, 10]]);
              }));

              return function (_x90, _x91) {
                return _ref67.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee52);
  }));

  return function (_x88, _x89) {
    return _ref66.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.FUTURE_BABY_IOSNEW, function () {
  var _ref70 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee54(_ref69, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            state = _ref69.state, commit = _ref69.commit, dispatch = _ref69.dispatch;
            return _context54.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref71 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee53(resolve, reject) {
                var cameraResultOne, cameraResultTwo;
                return regeneratorRuntime.wrap(function _callee53$(_context53) {
                  while (1) {
                    switch (_context53.prev = _context53.next) {
                      case 0:
                        console.log("FUTURE_BABY_NEW");
                        _context53.prev = 1;
                        _context53.next = 4;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          top: {
                            backgroundColor: "#f14a5e",
                            text: i18n.t("common.you"),
                            textColor: "#ffffff"
                          },
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("common.camera.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("common.camera.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.future_baby")
                          },
                          pop_animation: false
                        });

                      case 4:
                        cameraResultOne = _context53.sent;
                        _context53.next = 7;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          top: {
                            backgroundColor: "#603BF3",
                            text: i18n.t("common.partner"),
                            textColor: "#ffffff"
                          },
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("common.camera.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("common.camera.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.future_baby")
                          },
                          push_animation: false
                        });

                      case 7:
                        cameraResultTwo = _context53.sent;
                        dispatch(types.ROUTER_REPLACE, {
                          name: "composeProcess",
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              imageData: {
                                picFileUrl: "",
                                cameraResultOne: cameraResultOne,
                                cameraResultTwo: cameraResultTwo
                              },
                              transitionType: "forward"
                            })
                          }
                        });
                        _context53.next = 13;
                        break;

                      case 11:
                        _context53.prev = 11;
                        _context53.t0 = _context53["catch"](1);

                      case 13:
                      case "end":
                        return _context53.stop();
                    }
                  }
                }, _callee53, null, [[1, 11]]);
              }));

              return function (_x95, _x96) {
                return _ref71.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54);
  }));

  return function (_x93, _x94) {
    return _ref70.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.GET_FUTURE_BABY_RESULT, function () {
  var _ref73 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee56(_ref72, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            state = _ref72.state, commit = _ref72.commit, dispatch = _ref72.dispatch;
            return _context56.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref74 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee55(resolve, reject) {
                var key, ethnicity, sex, result;
                return regeneratorRuntime.wrap(function _callee55$(_context55) {
                  while (1) {
                    switch (_context55.prev = _context55.next) {
                      case 0:
                        _context55.prev = 0;
                        key = payload.key, ethnicity = payload.ethnicity, sex = payload.sex;
                        _context55.next = 4;
                        return FaceClient.req_future_baby(key, ethnicity, sex);

                      case 4:
                        result = _context55.sent;
                        console.log("GET_FUTURE_BABY_RESULT", result);
                        resolve(result);
                        _context55.next = 11;
                        break;

                      case 9:
                        _context55.prev = 9;
                        _context55.t0 = _context55["catch"](0);

                      case 11:
                      case "end":
                        return _context55.stop();
                    }
                  }
                }, _callee55, null, [[0, 9]]);
              }));

              return function (_x99, _x100) {
                return _ref74.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56);
  }));

  return function (_x97, _x98) {
    return _ref73.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.GET_FUTURE_BABY_RESULT_NEW, function () {
  var _ref76 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee58(_ref75, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) {
        switch (_context58.prev = _context58.next) {
          case 0:
            state = _ref75.state, commit = _ref75.commit, dispatch = _ref75.dispatch;
            return _context58.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref77 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee57(resolve, reject) {
                var photo1, photo2, result;
                return regeneratorRuntime.wrap(function _callee57$(_context57) {
                  while (1) {
                    switch (_context57.prev = _context57.next) {
                      case 0:
                        _context57.prev = 0;
                        photo1 = payload.photo1, photo2 = payload.photo2;
                        _context57.next = 4;
                        return FaceTG.queryBaby(photo1, photo2);

                      case 4:
                        result = _context57.sent;
                        console.log("GET_FUTURE_BABY_RESULT", result);
                        resolve(result);
                        _context57.next = 13;
                        break;

                      case 9:
                        _context57.prev = 9;
                        _context57.t0 = _context57["catch"](0);
                        console.log("GET_FUTURE_BABY_RESULT_NEW error", _context57.t0);
                        reject(_context57.t0);

                      case 13:
                      case "end":
                        return _context57.stop();
                    }
                  }
                }, _callee57, null, [[0, 9]]);
              }));

              return function (_x103, _x104) {
                return _ref77.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context58.stop();
        }
      }
    }, _callee58);
  }));

  return function (_x101, _x102) {
    return _ref76.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.PERSONAL_FUTRUE, function () {
  var _ref79 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee61(_ref78, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) {
        switch (_context61.prev = _context61.next) {
          case 0:
            state = _ref78.state, commit = _ref78.commit, dispatch = _ref78.dispatch;
            return _context61.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref80 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee60(resolve, reject) {
                var cameraResult, getResult;
                return regeneratorRuntime.wrap(function _callee60$(_context60) {
                  while (1) {
                    switch (_context60.prev = _context60.next) {
                      case 0:
                        _context60.prev = 0;
                        _context60.next = 3;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("common.camera.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("common.camera.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.personality_future")
                          }
                        });

                      case 3:
                        cameraResult = _context60.sent;
                        console.log('cameraResult', cameraResult);

                        getResult =
                        /*#__PURE__*/
                        function () {
                          var _ref81 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee59(callbackData) {
                            var value, base64, result;
                            return regeneratorRuntime.wrap(function _callee59$(_context59) {
                              while (1) {
                                switch (_context59.prev = _context59.next) {
                                  case 0:
                                    value = callbackData.value, base64 = callbackData.base64;
                                    commit(types.UPDATE_LOADING_STATUS, true);
                                    _context59.next = 4;
                                    return HoroScopeClient.req_person_future(value.nickName, value.birthdayMonth, value.birthdayDay);

                                  case 4:
                                    result = _context59.sent;
                                    console.log("result", JSON.parse(result.data));
                                    commit(types.UPDATE_LOADING_STATUS, false); // console.log('future result',JSON.parse(result.data))
                                    //有时候接口返回的数据会缺失

                                    if (result.status === 200 && JSON.parse(result.data).future_report && JSON.parse(result.data).now_report) {
                                      dispatch(types.ROUTER_REPLACE, {
                                        name: "personalFutrue",
                                        params: {
                                          routerTransition: "forward"
                                        },
                                        query: {
                                          tempKey: routerTempHelpers.setQueryTemp({
                                            resultData: result.data,
                                            picUrl: base64,
                                            userName: value.nickName
                                          })
                                        }
                                      });
                                    } else {
                                      _Toast(i18n.t("toast.minor_prablem"));
                                    }

                                  case 8:
                                  case "end":
                                    return _context59.stop();
                                }
                              }
                            }, _callee59);
                          }));

                          return function getResult(_x109) {
                            return _ref81.apply(this, arguments);
                          };
                        }(); //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction(result) {
                                //告诉下个页面next to do
                                getResult(result);
                              },
                              imageData: {
                                picUrl: cameraResult.base64,
                                picFileUrl: "",
                                points: cameraResult.points
                              },
                              title: "Personality & Future",
                              confirmShowScaning: true //点击confirm后显示scaning动画

                            })
                          }
                        });
                        _context60.next = 12;
                        break;

                      case 9:
                        _context60.prev = 9;
                        _context60.t0 = _context60["catch"](0);
                        reject(_context60.t0);

                      case 12:
                      case "end":
                        return _context60.stop();
                    }
                  }
                }, _callee60, null, [[0, 9]]);
              }));

              return function (_x107, _x108) {
                return _ref80.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context61.stop();
        }
      }
    }, _callee61);
  }));

  return function (_x105, _x106) {
    return _ref79.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.PALMISTRY_PHOTO, function () {
  var _ref83 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee63(_ref82, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee63$(_context63) {
      while (1) {
        switch (_context63.prev = _context63.next) {
          case 0:
            state = _ref82.state, commit = _ref82.commit, dispatch = _ref82.dispatch;
            return _context63.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref84 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee62(resolve, reject) {
                var cameraResultRight, scaningJump;
                return regeneratorRuntime.wrap(function _callee62$(_context62) {
                  while (1) {
                    switch (_context62.prev = _context62.next) {
                      case 0:
                        _context62.prev = 0;
                        _context62.next = 3;
                        return dispatch(types.TAKE_PHOTO, {
                          top: {
                            backgroundColor: "#603BF3",
                            text: i18n.t("common.camera.right_hand"),
                            textColor: "#ffffff"
                          },
                          type: "hand_right",
                          bottom: {
                            text: i18n.t("common.camera.frame_text")
                          }
                        });

                      case 3:
                        cameraResultRight = _context62.sent;

                        // console.log('cameraResultRight',cameraResultRight)
                        scaningJump = function scaningJump(cameraResultOne) {
                          dispatch(types.ROUTER_REPLACE, {
                            name: "scaningHand",
                            query: {
                              tempKey: routerTempHelpers.setQueryTemp({
                                imageData: cameraResultOne,
                                transitionType: "forward",
                                title: payload
                              })
                            }
                          });
                        }; //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction() {
                                //告诉下个页面next to do
                                scaningJump(cameraResultRight);
                              },
                              isShowHand: true,
                              imageData: {
                                picUrl: cameraResultRight,
                                picFileUrl: ""
                              }
                            })
                          }
                        });
                        _context62.next = 11;
                        break;

                      case 8:
                        _context62.prev = 8;
                        _context62.t0 = _context62["catch"](0);
                        reject(_context62.t0);

                      case 11:
                      case "end":
                        return _context62.stop();
                    }
                  }
                }, _callee62, null, [[0, 8]]);
              }));

              return function (_x112, _x113) {
                return _ref84.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context63.stop();
        }
      }
    }, _callee63);
  }));

  return function (_x110, _x111) {
    return _ref83.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.GET_CELE_RESULT, function () {
  var _ref86 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee65(_ref85, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee65$(_context65) {
      while (1) {
        switch (_context65.prev = _context65.next) {
          case 0:
            state = _ref85.state, commit = _ref85.commit, dispatch = _ref85.dispatch;
            return _context65.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref87 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee64(resolve, reject) {
                var result;
                return regeneratorRuntime.wrap(function _callee64$(_context64) {
                  while (1) {
                    switch (_context64.prev = _context64.next) {
                      case 0:
                        _context64.prev = 0;
                        _context64.next = 3;
                        return faceCelebrities.req_celebrities();

                      case 3:
                        result = _context64.sent;
                        console.log("GET_CELE_RESULT", result);
                        resolve(result);
                        _context64.next = 10;
                        break;

                      case 8:
                        _context64.prev = 8;
                        _context64.t0 = _context64["catch"](0);

                      case 10:
                      case "end":
                        return _context64.stop();
                    }
                  }
                }, _callee64, null, [[0, 8]]);
              }));

              return function (_x116, _x117) {
                return _ref87.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context65.stop();
        }
      }
    }, _callee65);
  }));

  return function (_x114, _x115) {
    return _ref86.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.GET_CELE_PHOTOS_RESULT, function () {
  var _ref89 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee67(_ref88, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee67$(_context67) {
      while (1) {
        switch (_context67.prev = _context67.next) {
          case 0:
            state = _ref88.state, commit = _ref88.commit, dispatch = _ref88.dispatch;
            return _context67.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref90 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee66(resolve, reject) {
                var pageNo, query, result;
                return regeneratorRuntime.wrap(function _callee66$(_context66) {
                  while (1) {
                    switch (_context66.prev = _context66.next) {
                      case 0:
                        pageNo = payload.pageNo, query = payload.query;
                        _context66.prev = 1;
                        _context66.next = 4;
                        return faceCelebrities.req_photos(query, pageNo);

                      case 4:
                        result = _context66.sent;
                        console.log("GET_CELE_PHOTOS_RESULT", result);
                        resolve(result);
                        _context66.next = 11;
                        break;

                      case 9:
                        _context66.prev = 9;
                        _context66.t0 = _context66["catch"](1);

                      case 11:
                      case "end":
                        return _context66.stop();
                    }
                  }
                }, _callee66, null, [[1, 9]]);
              }));

              return function (_x120, _x121) {
                return _ref90.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context67.stop();
        }
      }
    }, _callee67);
  }));

  return function (_x118, _x119) {
    return _ref89.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.CELE_PHOTOS, function () {
  var _ref92 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee69(_ref91, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee69$(_context69) {
      while (1) {
        switch (_context69.prev = _context69.next) {
          case 0:
            state = _ref91.state, commit = _ref91.commit, dispatch = _ref91.dispatch;
            return _context69.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref93 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee68(resolve, reject) {
                var from, starPic, cameraResult, scaningJump;
                return regeneratorRuntime.wrap(function _callee68$(_context68) {
                  while (1) {
                    switch (_context68.prev = _context68.next) {
                      case 0:
                        from = payload.from, starPic = payload.starPic;
                        _context68.prev = 1;
                        _context68.next = 4;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          top: {
                            backgroundColor: "#f14a5e",
                            text: i18n.t("common.you"),
                            textColor: "#ffffff"
                          },
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("common.camera.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("common.camera.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.future_baby")
                          }
                        });

                      case 4:
                        cameraResult = _context68.sent;

                        scaningJump = function scaningJump(cameraResultOne, cameraResultTwo) {
                          console.log("cameraResultOne, cameraResultTwo", cameraResultOne, cameraResultTwo);
                          dispatch(types.ROUTER_REPLACE, {
                            name: "composeProcess",
                            query: {
                              tempKey: routerTempHelpers.setQueryTemp({
                                imageData: {
                                  picFileUrl: "",
                                  cameraResultOne: cameraResultOne,
                                  cameraResultTwo: cameraResultTwo,
                                  starOne: true
                                },
                                transitionType: "forward"
                              })
                            }
                          });
                        }; //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction(image_two) {
                                //告诉下个页面next to do
                                scaningJump(starPic, image_two);
                              },
                              goBackFunction: function goBackFunction() {
                                dispatch(types.CELE_PHOTOS, {
                                  from: from,
                                  starPic: starPic
                                });
                                setTimeout(function () {
                                  dispatch(types.ROUTER_GO_BACK, -1);
                                }, 400);
                              },
                              imageData: {
                                picUrl: cameraResult.base64,
                                picFileUrl: cameraResult.filePath,
                                points: cameraResult.points
                              },
                              editFilePath: true
                            })
                          }
                        });
                        _context68.next = 11;
                        break;

                      case 9:
                        _context68.prev = 9;
                        _context68.t0 = _context68["catch"](1);

                      case 11:
                      case "end":
                        return _context68.stop();
                    }
                  }
                }, _callee68, null, [[1, 9]]);
              }));

              return function (_x124, _x125) {
                return _ref93.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context69.stop();
        }
      }
    }, _callee69);
  }));

  return function (_x122, _x123) {
    return _ref92.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.GET_CELEBRITES_PHOTOS, function () {
  var _ref95 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee72(_ref94, payload) {
    var state, commit, dispatch, getters;
    return regeneratorRuntime.wrap(function _callee72$(_context72) {
      while (1) {
        switch (_context72.prev = _context72.next) {
          case 0:
            state = _ref94.state, commit = _ref94.commit, dispatch = _ref94.dispatch, getters = _ref94.getters;
            return _context72.abrupt("return", new _Promise(
            /*#__PURE__*/
            function () {
              var _ref96 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee71(resolve, reject) {
                var cameraResult, compressPhoto, compressBaseData, nextFunction;
                return regeneratorRuntime.wrap(function _callee71$(_context71) {
                  while (1) {
                    switch (_context71.prev = _context71.next) {
                      case 0:
                        _context71.prev = 0;
                        _context71.next = 3;
                        return dispatch(types.TAKE_PHOTO_EX, {
                          bottom: {
                            // backgroundColor: "#f14a5e",
                            text: i18n.t("common.camera.camera_bottom_text"),
                            textColor: "#ffffff",
                            hightLightTextColor: "#FFDD63",
                            hightLightText: [i18n.t("common.camera.camera_hight_light_text")]
                          },
                          title: {
                            text: i18n.t("home_page.main_function_list.elebrities")
                          }
                        });

                      case 3:
                        cameraResult = _context71.sent;
                        _context71.next = 6;
                        return canvasCompress("data:image/jpeg;base64," + cameraResult.base64);

                      case 6:
                        compressPhoto = _context71.sent;
                        compressBaseData = compressPhoto.split(',')[1]; //获取数据 

                        nextFunction =
                        /*#__PURE__*/
                        function () {
                          var _ref97 = _asyncToGenerator(
                          /*#__PURE__*/
                          regeneratorRuntime.mark(function _callee70(result) {
                            var lunchData, celebrities_api_switch, celeResult, tempKey, alignImage, alignFace, faceResult;
                            return regeneratorRuntime.wrap(function _callee70$(_context70) {
                              while (1) {
                                switch (_context70.prev = _context70.next) {
                                  case 0:
                                    _context70.prev = 0;
                                    lunchData = getters[types.GETTER_LAUNCH_CONFIG];
                                    celebrities_api_switch = lunchData && lunchData.celebrities_api_switch; // 0  老接口， 1，我们自己的新接口，2，别人的新接口

                                    if (!(celebrities_api_switch === 1)) {
                                      _context70.next = 23;
                                      break;
                                    }

                                    _context70.prev = 4;
                                    _context70.next = 7;
                                    return celebritiesNew(result);

                                  case 7:
                                    celeResult = _context70.sent;

                                    if (!(celeResult && celeResult.length > 0)) {
                                      _context70.next = 15;
                                      break;
                                    }

                                    _context70.next = 11;
                                    return routerTempHelpers.setQueryTemp({
                                      resultData: celeResult,
                                      originPic: result
                                    });

                                  case 11:
                                    tempKey = _context70.sent;
                                    dispatch(types.ROUTER_REPLACE, {
                                      name: "getNewCelebrites",
                                      params: {
                                        transitionType: "forward",
                                        showVipRightNow: true
                                      },
                                      query: {
                                        tempKey: tempKey
                                      }
                                    });
                                    _context70.next = 16;
                                    break;

                                  case 15:
                                    commit(types.SHOW_NETWORK_TOAST, function () {
                                      dispatch(types.ROUTER_GO_BACK, -1);
                                    });

                                  case 16:
                                    _context70.next = 21;
                                    break;

                                  case 18:
                                    _context70.prev = 18;
                                    _context70.t0 = _context70["catch"](4);
                                    commit(types.SHOW_NETWORK_TOAST, function () {
                                      dispatch(types.ROUTER_GO_BACK, -1);
                                    });

                                  case 21:
                                    _context70.next = 35;
                                    break;

                                  case 23:
                                    _context70.next = 25;
                                    return faceIdeaClient.get_align_image(result);

                                  case 25:
                                    alignImage = _context70.sent;

                                    if (!(alignImage && alignImage.data && alignImage.data.list_images[0] && alignImage.data.list_images[0].list_face[0])) {
                                      _context70.next = 34;
                                      break;
                                    }

                                    alignFace = alignImage.data.list_images[0].list_face[0].face.base64;
                                    _context70.next = 30;
                                    return faceIdeaClient.get_celebrities(alignFace);

                                  case 30:
                                    faceResult = _context70.sent;

                                    if (faceResult && faceResult.result > 0) {
                                      dispatch(types.ROUTER_REPLACE, {
                                        name: "getCelebrites",
                                        params: {
                                          transitionType: "forward",
                                          showVipRightNow: true
                                        },
                                        query: {
                                          tempKey: routerTempHelpers.setQueryTemp({
                                            resultData: faceResult.data.list_face,
                                            originPic: result
                                          })
                                        }
                                      });
                                    } else {
                                      commit(types.SHOW_NETWORK_TOAST, function () {
                                        dispatch(types.ROUTER_GO_BACK, -1);
                                      });
                                    }

                                    _context70.next = 35;
                                    break;

                                  case 34:
                                    commit(types.SHOW_FACE_TOAST, function () {
                                      dispatch(types.ROUTER_GO_BACK, -1);
                                      dispatch(types.GET_CELEBRITES_PHOTOS);
                                    });

                                  case 35:
                                    _context70.next = 40;
                                    break;

                                  case 37:
                                    _context70.prev = 37;
                                    _context70.t1 = _context70["catch"](0);

                                    if (_context70.t1 && _context70.t1.status && _context70.t1.status === 1) {
                                      commit(types.SHOW_NETWORK_TOAST, function () {
                                        dispatch(types.ROUTER_GO_BACK, -1);
                                      });
                                    }

                                  case 40:
                                  case "end":
                                    return _context70.stop();
                                }
                              }
                            }, _callee70, null, [[0, 37], [4, 18]]);
                          }));

                          return function nextFunction(_x130) {
                            return _ref97.apply(this, arguments);
                          };
                        }(); //跳转路由到确定页面:


                        dispatch(types.ROUTER_PUSH, {
                          name: "confirmPhoto",
                          params: {
                            transitionType: "static"
                          },
                          query: {
                            tempKey: routerTempHelpers.setQueryTemp({
                              nextStepFunction: function nextStepFunction() {
                                //告诉下个页面next to do
                                nextFunction(compressBaseData);
                              },
                              imageData: {
                                picUrl: compressBaseData,
                                points: cameraResult.points
                              },
                              confirmShowScaning: true
                            })
                          }
                        });
                        _context71.next = 14;
                        break;

                      case 12:
                        _context71.prev = 12;
                        _context71.t0 = _context71["catch"](0);

                      case 14:
                      case "end":
                        return _context71.stop();
                    }
                  }
                }, _callee71, null, [[0, 12]]);
              }));

              return function (_x128, _x129) {
                return _ref96.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context72.stop();
        }
      }
    }, _callee72);
  }));

  return function (_x126, _x127) {
    return _ref95.apply(this, arguments);
  };
}()), _actions);
export default actions;